import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'pastdue',
  async getComponent () {
    const {
      default: PastdueContainer
    } = await import(/* webpackChunkName: "pastdue-container" */ './containers/PastdueContainer')
      .catch(handleChunkLoadError);
    return PastdueContainer;
  }
});
